import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/cbs";

const UPDATE_REMINDERS = `
    update_reminders(
        reminderable_id: $reminderable_id, 
        reminderable_type: $reminderable_type,
        list: $list) 
    {
		id
		period_type
		milestone_type
		value
		emails
		relations {
			id
			type
			name
		}
		content
    }`;

const DELETE_REMINDER = `delete_reminder(id: $id) {id}`;

export default {
	init() {},

	updateReminder(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateReminders (
					$reminderable_id: Int!,
                    $reminderable_type: String!,
                    $list: [ReminderInput]
					) {
						${UPDATE_REMINDERS}
					}
					`,
				variables: {
					reminderable_id: payload.reminderable_id,
					reminderable_type: payload.reminderable_type,
					list: payload.list
				}
			})
			.then(response => {
				return response.data.update_reminders;
			});
	},

	deleteReminder(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateReminders (
					$id: Int!,
					) {
						${DELETE_REMINDER}
					}
					`,
				variables: {
					id: payload.id
				}
			})
			.then(response => {
				return response.data.delete_reminder;
			});
	}
};
